import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

export const TranslateTestingModule = TranslateModule.forRoot({
    loader: { provide: TranslateLoader, useValue: {} }
});
